const ID_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
const ID_LENGTH = 6;

/**
 * A short opaque id for a registry entry.
 *
 * Short because the agent reads these and passes them back: an id it has to copy
 * accurately should be a few characters, not a UUID. `isTaken` re-rolls on collision,
 * which a 6-character id needs at registry sizes well below the birthday bound.
 */
export function generateRegistryId(isTaken: (id: string) => boolean): string {
    let result = '';
    for (let i = 0; i < ID_LENGTH; i++) {
        result += ID_CHARS.charAt(Math.floor(Math.random() * ID_CHARS.length));
    }
    return isTaken(result) ? generateRegistryId(isTaken) : result;
}
